module.exports = __webpack_public_path__ + "static/img/aboutUs.a71eb74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs.png
// module id = BbTC
// module chunks = 1